import { toast } from "react-toastify";
import { get, post, put } from "../../../services/api";
import {
  CONFIRMED_GET_CANDIDATES,
  CONFIRMED_GET_CANDIDATE,
  CONFIRMED_GET_CANDIDATE_JOB,
  GET_CANDIDATE_FAILED_ACTION,
  ADD_CANDIDATE_FAILED,
  ADD_CANDIDATE_SUCCESS,
  UPDATE_CANDIDATE_SUCCESS,
  UPDATE_CANDIDATE_FAILED,
} from "./candidateTypes";

export function candidateFailedAction(data) {
  return {
    type: GET_CANDIDATE_FAILED_ACTION,
    payload: data,
  };
}
export function addCandidateFailedAction(data) {
  return {
    type: ADD_CANDIDATE_FAILED,
    payload: data,
  };
}
export function addCandidateSuccessAction(data) {
  return {
    type: ADD_CANDIDATE_SUCCESS,
    payload: data,
  };
}

export function updateCandidateFailedAction(data) {
  return {
    type: UPDATE_CANDIDATE_FAILED,
    payload: data,
  };
}
export function updateCandidateSuccessAction(data) {
  return {
    type: UPDATE_CANDIDATE_SUCCESS,
    payload: data,
  };
}
export function getCandidateList(data) {
  return {
    type: CONFIRMED_GET_CANDIDATES,
    payload: data,
  };
}

export function getCandidateJobList(data) {
  return {
    type: CONFIRMED_GET_CANDIDATE_JOB,
    payload: data,
  };
}

export function getCandidate(data) {
  return {
    type: CONFIRMED_GET_CANDIDATE,
    payload: data,
  };
}

export function getCandidates(token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/candidate", token);
      dispatch(getCandidateList(res));
    } catch (e) {
      dispatch(
        candidateFailedAction(
          "Something went wrong while fetching candidates.."
        )
      );
    }
  };
}


export function getCandidateById(id, token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/candidate/"+id, token);
      dispatch(getCandidate(res));
    } catch (e) {
      dispatch(
        candidateFailedAction(
          "Something went wrong while fetching candidates.."
        )
      );
    }
  };
}


export function getCandidatesJob(id, token, weekStartDate = null, weekEndDate = null) {
  return async (dispatch) => {
    try {
      let url = `/api/job/candidate/${id}`;
      const params = new URLSearchParams();
      
      if (weekStartDate && weekEndDate) {
        params.append('weekStartDate', weekStartDate);
        params.append('weekEndDate', weekEndDate);
        url += `?${params.toString()}`;
      }
      
      const res = await get(url, token);
      
      // Remove duplicates based on candidateId and jobId
      const uniqueRes = res.filter((item, index, self) => 
        index === self.findIndex((t) => 
          t.candidateId === item.candidateId && 
          t.jobId === item.jobId
        )
      );
      
      dispatch(getCandidateJobList(uniqueRes));
    } catch (e) {
      dispatch(
        candidateFailedAction(
          "Something went wrong while fetching candidates.."
        )
      );
    }
  };
}

export function addCandidates(data, setModal, token, resetForm) {
  return async (dispatch) => {
    try {
      const res = await post("/api/candidate", data, token);
      if (res.status === 200) {
        toast.success("Candidate added successfully.");
        const res = await get("/api/candidate", token);
        dispatch(getCandidateList(res));
        if (resetForm) {
          resetForm();
        }
        setModal(false);
      } else {
        dispatch(
          addCandidateFailedAction(
            "Something went wrong while adding candidate. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        addCandidateFailedAction(
          "Something went wrong while adding candidate. Please try again"
        )
      );
    }
  };
}


export function updateCandidates(data, setModal, id, token) {
  return async (dispatch) => {
    try {
      const res = await put(`/api/candidate/${id}`, data, token);
      if (res.status === 200) {
        toast.success("Candidate updated successfully.");
        const res = await get("/api/candidate", token);
        dispatch(getCandidateList(res));
        setModal(false);
      } else {
        dispatch(
          updateCandidateFailedAction(
            "Something went wrong while updated candidate. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        updateCandidateFailedAction(
          "Something went wrong while updated candidate. Please try again"
        )
      );
    }
  };
}


